import type { IHistoryEntry } from '@platform/core/types';

/**
 * Події історії без значень полів з персональними даними, прихованих від користувача (`restricted` — permissions.restrictedFields запису;
 * сервер маскує їх і сам, це захист інтерфейсу): «було» й «стало» таких полів зникають, подія лишається «оновив(-ла) «Поле»» — і в
 * стрічці, і в CSV «Експорт історії». Чиста функція.
 */
export function maskHistory(entries: readonly IHistoryEntry[], restricted: readonly string[]): IHistoryEntry[] {
  if (!restricted.length) return [...entries];
  return entries.map((e) => (e.field && restricted.includes(e.field) && (e.from != null || e.to != null) ? { ...e, from: null, to: null } : e));
}
